<script>
import {
  Bar
} from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'options'],
  watch: {
    data(val) {
      this.renderChart(this.data, this.options);
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/bar.vue